import { CloseEditorIfOpenedEvent } from 'modules/application/detail/portal-submodule-builder/templates/builder/BuilderController';
import { SendMessageActionSettings } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/SendMessageActionSettings';
import { ActionController } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/actions/ActionController';
export class MetadataController extends ActionController {
    static $inject = ['action', 'close', '$onStateChanged', 'SidebarContentService', 'CodeEditorService', 'UndoRedoService', 'state', '$rootScope', '$scope'];
    constructor(action, close, $onStateChanged, SidebarContentService, CodeEditorService, UndoRedoService, state, $rootScope, $scope) {
        super(close, action, $onStateChanged, UndoRedoService, state, { $rootScope, $scope });
        this.SidebarContentService = SidebarContentService;
        this.CodeEditorService = CodeEditorService;
        this.UndoRedoService = UndoRedoService;
        this.state = state;
        this.expandToggled = false;
        this.initializeMetadata();
    }
    create() {
        return new SendMessageActionSettings();
    }
    errorOnAdd() {
        console.error('Could not add a new key');
    }
    initializeMetadata() {
        if (!this.action.settings.metadata) {
            this.action.settings.metadata = {};
        }
    }
    async toggleExpandValue($event) {
        switch (this.expandToggled) {
            case true:
                this.SidebarContentService.cleanAndClose(false, this.sidebarEditor);
                setTimeout(() => {
                    if ($event.toggled) {
                        this.openCodeEditor($event);
                    }
                }, 550);
                break;
            case false:
                this.openCodeEditor($event);
                break;
        }
    }
    async openCodeEditor({ model, editorLanguage, toggled }) {
        let newCode = '';
        this.sidebarEditor = await this.CodeEditorService.openCodeEditor({
            code: model.value,
            language: editorLanguage,
            editorWasCreated: this.editorWasCreated.bind(this),
            SidebarContentService: this.SidebarContentService,
            onCodeEditorChange: ({ code }) => {
                newCode = code;
            },
            onSaveSource: () => {
                model.value = newCode;
            },
        });
        this.expandToggled = true;
        const deregisterCloseEditorEvent = this.$rootScope.$on(CloseEditorIfOpenedEvent, () => {
            this.SidebarContentService.cleanAndClose(false, this.sidebarEditor);
        });
        await this.sidebarEditor.closeDeferred.promise; // when code editor close
        deregisterCloseEditorEvent();
        this.expandToggled = false;
    }
    /**
     * Callback executed after code editor created
     * @param object - Code editor standalone
     */
    editorWasCreated({ editor }) {
        this.isMonacoLoading = false;
        setTimeout(() => {
            editor.layout();
        }, 500);
    }
}
MetadataController.$inject = ['action', 'close', '$onStateChanged', 'SidebarContentService', 'CodeEditorService', 'UndoRedoService', 'state', '$rootScope', '$scope'];
